/* ClayGo — kategori / arama davranışları */
(function () {
  'use strict';

  /* Sentinel göründüğünde kaç kez otomatik yükleyeceğiz. Bu sınıra gelince
     kullanıcı butona basana kadar duruyoruz: 1643 ürünlü kategoride sonsuz
     zincir başlamasın ve footer'a ulaşılabilsin. */
  var MAX_AUTO_LOADS = 5;
  var ROOT_MARGIN = '700px 0px';

  var autoLoads = 0;
  var observer = null;
  var gridObserver = null;

  function loadMoreButton() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return null;
    return container.querySelector('.pagination button[is="load-more-button"]');
  }

  function sentinel() {
    return document.querySelector('[data-cg-infinite]');
  }

  function doneMessage() {
    return document.querySelector('[data-cg-infinite-done]');
  }

  /* lazysizes yeni DOM'u kendi MutationObserver'ı ile yakalar ama async
     yüklendiği için ilk AJAX cevabı ona yetişmeyebiliyor; garanti olsun diye
     elle tetikliyoruz. */
  function refreshLazysizes() {
    if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) {
      window.lazySizes.loader.checkElems();
    }
  }

  function markAppended(nodes) {
    nodes.forEach(function (node, i) {
      if (!(node instanceof HTMLElement)) return;
      if (!node.classList.contains('f-column')) return;
      node.style.setProperty('--cg-appended-index', String(i % 8));
      node.setAttribute('data-cg-appended', '');
    });
  }

  /* "Hepsini gördün" yazısı sadece gerçekten sayfalama olan listelerde,
     son sayfa yüklendikten sonra çıkar. Tek sayfalık kategorilerde hiç çıkmaz. */
  function updateDoneState() {
    var message = doneMessage();
    var target = sentinel();
    if (!message || !target) return;

    var hadNextPage = target.getAttribute('data-cg-has-next') === 'true';
    message.hidden = !hadNextPage || !!loadMoreButton();
  }

  function watchGrid() {
    var list = document.getElementById('ProductsList');
    if (!list || !window.MutationObserver) return;

    if (gridObserver) gridObserver.disconnect();
    gridObserver = new MutationObserver(function (mutations) {
      var added = [];
      mutations.forEach(function (mutation) {
        Array.prototype.push.apply(added, Array.prototype.slice.call(mutation.addedNodes));
      });
      if (!added.length) return;

      markAppended(added);
      refreshLazysizes();
      updateDoneState();
      document.dispatchEvent(new CustomEvent('claygo:products-appended', { detail: { count: added.length } }));
      setTimeout(retriggerSentinel, 350);
    });
    gridObserver.observe(list, { childList: true });
  }

  function onSentinelVisible(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var button = loadMoreButton();
      if (!button) {
        updateDoneState();
        return;
      }
      if (button.classList.contains('btn--loading')) return;
      if (autoLoads >= MAX_AUTO_LOADS) return;

      autoLoads += 1;
      button.click();
    });
  }

  /* IntersectionObserver sadece durum DEĞİŞİRSE tetiklenir. Yeni ürünler eklendikten
     sonra sentinel hâlâ görünür alanda kalırsa callback gelmez; yeniden observe
     ederek durumu tekrar okutuyoruz. */
  function retriggerSentinel() {
    if (!observer) return;
    var target = sentinel();
    if (!target) return;
    observer.unobserve(target);
    observer.observe(target);
  }

  function watchSentinel() {
    var target = sentinel();
    if (!target || !('IntersectionObserver' in window)) return;

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(onSentinelVisible, { rootMargin: ROOT_MARGIN });
    observer.observe(target);
  }

  /* Kullanıcı kendi eliyle "Daha fazla"ya basınca otomatik sayacı sıfırlanır. */
  function watchManualClicks() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('button[is="load-more-button"]');
      if (button) autoLoads = 0;
    });
  }

  /* Filtre/sıralama sonrası bütün grid yeniden basılıyor: sayaç ve gözlemciler resetlenir. */
  function onCollectionRerendered() {
    autoLoads = 0;
    watchGrid();
    watchSentinel();
    refreshLazysizes();
    updateDoneState();
    initDescriptionToggles();
    initSubcatSliderNav();
  }

  /* Drawer/modal kapanma animasyonu bir şekilde tamamlanmazsa body'de
     modal-show kalıp sayfayı kilitliyor. Açık bir modal yoksa temizliyoruz. */
  function unlockStaleScrollLock() {
    var body = document.body;
    if (!body.classList.contains('modal-show') && !body.classList.contains('modal-showing')) return;

    var openModal = document.querySelector(
      'drawer-component[open], modal-component[open], basic-modal[open], spotlight-pick[open]'
    );
    if (openModal) return;

    body.classList.remove('modal-show');
    body.classList.remove('modal-showing');
  }

  function watchScrollLock() {
    ['keyup', 'popstate', 'pageshow'].forEach(function (type) {
      window.addEventListener(type, function () {
        setTimeout(unlockStaleScrollLock, 400);
      });
    });

    var drawer = document.getElementById('FacetDrawer');
    if (drawer) {
      drawer.addEventListener('drawer:handleAfterHide', function () {
        setTimeout(unlockStaleScrollLock, 400);
      });
    }
  }

  /* line-clamp scrollHeight'i kısaltılmış yüksekliğe eşitler; tam metni klonla ölç */
  function descriptionOverflows(body) {
    if (!body.clientWidth) return false;

    var clone = body.cloneNode(true);
    clone.removeAttribute('data-cg-desc-body');
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';
    clone.style.display = 'block';
    clone.style.webkitLineClamp = 'unset';
    clone.style.webkitBoxOrient = 'unset';
    clone.style.width = body.clientWidth + 'px';
    body.parentNode.appendChild(clone);

    var overflows = clone.offsetHeight > body.offsetHeight + 2;
    clone.remove();
    return overflows;
  }

  /* Koleksiyon açıklaması mobilde ... ile kesilirse "Daha fazla oku" göster */
  function initDescriptionToggles() {
    var mq = window.matchMedia('(max-width: 767px)');

    function refresh() {
      document.querySelectorAll('[data-cg-desc]').forEach(function (wrap) {
        var body = wrap.querySelector('[data-cg-desc-body]');
        var btn = wrap.querySelector('[data-cg-desc-toggle]');
        if (!body || !btn) return;

        if (!btn.dataset.cgBound) {
          btn.dataset.cgBound = '1';
          btn.addEventListener('click', function () {
            var expanded = wrap.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            var more = btn.querySelector('[data-cg-desc-more]');
            var less = btn.querySelector('[data-cg-desc-less]');
            if (more) more.hidden = expanded;
            if (less) less.hidden = !expanded;
          });
        }

        if (!mq.matches || wrap.classList.contains('is-expanded')) return;

        btn.hidden = !descriptionOverflows(body);
      });
    }

    refresh();
    window.addEventListener('resize', refresh);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }
  }

  /* Alt kategori slider: tüm kartlar sığıyorsa okları gizle */
  function initSubcatSliderNav() {
    document.querySelectorAll('.cg-subcat-slider').forEach(function (section) {
      var list = section.querySelector('collection-list');
      var track = section.querySelector('.collection-list__items');
      if (!list || !track) return;

      function check() {
        if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
          section.classList.remove('is-all-visible');
          return;
        }
        var fits = track.scrollWidth <= list.clientWidth + 4;
        section.classList.toggle('is-all-visible', fits);
      }

      check();
      window.addEventListener('resize', check);
    });
  }

  function init() {
    watchGrid();
    watchSentinel();
    watchManualClicks();
    watchScrollLock();
    updateDoneState();
    initDescriptionToggles();
    initSubcatSliderNav();

    document.addEventListener('collection:rerendered', onCollectionRerendered);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
